export interface Guest {
  guestId: number;
  firstName: string;
  lastName: string;

  email?: string;
  phone?: string;
  address?: string;
  guestIdCard?: string;
  country?: string;
  state?: string;
  city?: string;

  isCheckedIn?: boolean;
  isCheckedOut?: boolean;

  checkInTime?: string;   // ISO 8601 string
  checkOutTime?: string;  // ISO 8601 string

  preferences?: string;
  loyaltyProgram?: string;
  loyaltyProgramId?: string;
  points?: number;
  eliteStatus?: string;
  historyOfStays?: string;
  notes?: string;
  visitDate?: string;     // YYYY-MM-DD

  paymentDetails?: string;
  paymentMethod?: string;
  creditCardNumber?: string;
  cardholderName?: string;
  cardExpirationDate?: string;
  cvv?: string;
  billingAddress?: string;
  paymentAmount?: number;
  currency?: string;
  transactionId?: string;
  paymentTimestamp?: string; // ISO 8601 string

  roomNumber?: number;
  isTravelAgent?: boolean;
  title?: string;
  stateId?: number;
  password?: string;
  zipCode?: string;
  roomId?: number;
  guidId?: string;
  agentId?: number;
  billTo?: string;
  businessSourcess?: string;
  checkinId?: number;
  commissionId?: number;
  commissionPlan?: string;
  company?: string;
  gender?: string;
  modeOfPayment?: string;
  paymentTerms?: string;
  rateId?: number;
  rates?: string;
  releaseDate?: string;   // YYYY-MM-DD
  specialOfferId?: number;
  taxExemptionId?: string;
  dateOfBirth?: string;   // YYYY-MM-DD
  idType?: string;
  issueDateofId?: string; // YYYY-MM-DD
  expiryDate?: string;    // YYYY-MM-DD
  nationality?: string;
  language?: string;
  billingCountry?: string;

  married?: boolean;
  single?: boolean;
  divorced?: boolean;
  numberOfChildren?: number;
  numberOfAdults?: number;
  withChildren?: boolean;

  amount?: number;
  requestId?: number;
  genderId?: number;
  titleId?: number;
  guestStatus?: string;
  sources?: string;

  dateAdded?: string;     // ISO 8601 string
  updatedAt?: string;     // ISO 8601 string
}


export const initializedGuest: Guest = {
  guestId: 0,
  firstName: "",
  lastName: "",

  email: "",
  phone: "",
  address: "",
  guestIdCard: "",
  country: "",
  state: "",
  city: "",

  isCheckedIn: false,
  isCheckedOut: false,

  checkInTime: "",
  checkOutTime: "",

  preferences: "",
  loyaltyProgram: "",
  loyaltyProgramId: "",
  points: 0,
  eliteStatus: "",
  historyOfStays: "",
  notes: "",
  visitDate: "",

  paymentDetails: "",
  paymentMethod: "",
  creditCardNumber: "",
  cardholderName: "",
  cardExpirationDate: "",
  cvv: "",
  billingAddress: "",
  paymentAmount: 0,
  currency: "",
  transactionId: "",
  paymentTimestamp: "",

  roomNumber: 0,
  isTravelAgent: false,
  title: "",
  stateId: 0,
  password: "",
  zipCode: "",
  roomId: 0,
  guidId: "",
  agentId: 0,
  billTo: "",
  businessSourcess: "",
  checkinId: 0,
  commissionId: 0,
  commissionPlan: "",
  company: "",
  gender: "",
  modeOfPayment: "",
  paymentTerms: "",
  rateId: 0,
  rates: "",
  releaseDate: "",
  specialOfferId: 0,
  taxExemptionId: "",
  dateOfBirth: "",
  idType: "",
  issueDateofId: "",
  expiryDate: "",
  nationality: "",
  language: "",
  billingCountry: "",

  married: false,
  single: false,
  divorced: false,
  numberOfChildren: 0,
  numberOfAdults: 0,
  withChildren: false,

  amount: 0,
  requestId: 0,
  genderId: 0,
  titleId: 0,
  guestStatus: "",
  sources: "",

  dateAdded: "",
  updatedAt: "",
};